__turbopack_context__.v({
  "button": "styles-module-scss-module__1__qma__button",
});
